/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum NotificationTypeEnum {
    Email = 'email',
    App = 'app'
}

export function NotificationTypeEnumFromJSON(json: any): NotificationTypeEnum {
    return NotificationTypeEnumFromJSONTyped(json, false);
}

export function NotificationTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationTypeEnum {
    return json as NotificationTypeEnum;
}

export function NotificationTypeEnumToJSON(value?: NotificationTypeEnum | null): any {
    return value as any;
}

